import * as React from "react";
import { Box, Flex, Image } from "../../shared";
import { ActivityIndicator } from "../index";

interface CardImageProps {
  svg: string;
  common: string;
}

const CardImage: React.FC<CardImageProps> = ({ svg, common }) => {
  const [imageIsLoading, setImageIsLoading] = React.useState(true);
  const imageRef = React.useRef<HTMLImageElement>(null);
  const hasFlag = Boolean(svg && svg.length > 0);

  React.useEffect(() => {
    if (!hasFlag) {
      setImageIsLoading(false);
      return;
    }
    if (imageRef?.current?.complete) {
      setImageIsLoading(false);
    }
  }, [setImageIsLoading, common, hasFlag]);

  return (
    <Box
      css={{
        position: "relative",
        p: "30%",
        borderRadius: "none",
      }}
    >
      {hasFlag && imageIsLoading && (
        <Flex
          css={{
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ActivityIndicator />
        </Flex>
      )}
      {hasFlag && (
        <Image src={svg} alt={common} ref={imageRef} />
      )}
    </Box>
  );
};

export default CardImage;
